export default __webpack_public_path__ + "static/media/6.7fdbca43.png";